/* The mockup's `.chip` (32px pill) and the panel it opens. */
.chip {
  display: inline-flex;
  flex: none;
  align-items: center;
  gap: 6px;
  max-inline-size: 220px;
  block-size: var(--control-height);
  padding: 0 10px;
  border: 1px solid var(--border-control);
  border-radius: var(--radius-pill);
  background: var(--surface-raised);
  color: var(--text-muted);
  font: inherit;
  font-size: var(--font-size-12);
  font-weight: var(--font-weight-medium);
  white-space: nowrap;
  cursor: pointer;
}

.chip:hover {
  background: var(--state-hover);
  color: var(--text);
}

.chip:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}

.chip[aria-expanded="true"] {
  color: var(--text);
}

.label {
  overflow: hidden;
  text-overflow: ellipsis;
}

.panel {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  padding: var(--space-3) var(--space-4);
}

.title {
  margin: 0;
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-semibold);
}
